module.exports = __webpack_public_path__ + "img/rodrigo.0af0c0d1.png";